/* eslint-disable react/prop-types */
import React, { useMemo, useContext } from "react";
import TableLayout from "./table-layout";
import PropTypes from "prop-types";
import { useSortBy, useTable } from "react-table";
import { QuotationsData } from "../../contexts";
import { toast } from "react-toastify";
import "../../styles/Tableinstance.scss";
import { request } from "../../config/helpers/axios-instance";
import { BsFillTrashFill } from 'react-icons/bs'
import { MdModeEditOutline } from "react-icons/md"
import { useNavigate } from "react-router-dom";
import { ALL_QUOTATIONS_TYPE, PRESORTED_QUOTATIONS_TYPE, STRIPS_QUOTATIONS_TYPE } from "../../utils/constants.js";
import { getTenantId } from "../../utils/helpers";
import { TENANT_COMPANY_MAP } from "../../utils/constants";

// eslint-disable-next-line no-undef
const Constants = require("./Constants");
const tenantId = getTenantId();
const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;
const baseColumns = isEasydose
    ? Constants.QUOTATIONS_COLUMN.filter((col) => col.accessor !== "partner.name" && col.accessor !== "inventoryId")
    : Constants.QUOTATIONS_COLUMN;

// Exported (alongside the default TableInstance export below) so
// src/v2/pharmacy/pages/quotations can compose its own, wider column set using this
// EXACT renderer -- same Delete/Edit action buttons -- rather than forking it. Mirrors
// why src/components/orderTable/table-instance.jsx exports its own Cell.
//
// Cell2 (the status <select>) is deliberately NOT exported alongside it: it hardcodes
// Constants.STATUS_MAP/STATUS_MAP_REVERSE internally, which is missing
// CONVERTED_TO_ORDER/QUOTE_SHARED/QUOTATION_SHARED (20 live enum values, 17 mapped) --
// a quotation whose status falls outside that map renders no `selected` option, so the
// <select> silently shows its first option, and any change from it overwrites the real
// status with the wrong one. The pharmacy table drives its status column from
// QUOTATION_STATUS_REGISTRY instead, which covers all 20 values with friendly labels;
// see src/v2/pharmacy/pages/quotations/table-instance.jsx.
export const Cell = (row, reOrderModalClick, handleDeleteRow, quotationType) => {
    const navigate = useNavigate();

    return (
        <div className="w-full h-full flex flex-row gap-[3px] items-center">
            {Constants.COLUMNS_FUCTIONALITIES[quotationType].includes("Delete") && row?.row?.original?.payments?.filter(payment => payment.status === 'SUCCESS' || payment.status === 'PENDING').length === 0 && < button
                id="create-order"
                className="px-4 py-2 rounded-2xl font-sans create-order bg-[red]/[0.85]"
                onClick={async () => {
                    if (confirm("Do you wish to delete the order")) {
                        const res = await request({
                            url: `/quotation/admin/id/${row?.cell?.row?.values?.id}`,
                            method: "DELETE",
                        })
                        if (res && res.data.success) {
                            // Here we have to delete the row
                            handleDeleteRow(row?.cell?.row?.values?.id);
                        }
                        else if (res && !res.data.success) {
                            toast.error(res.data.error || "Please Try After Sometime")
                        }
                    }
                }}>
                <BsFillTrashFill />
            </button>}
            {/* No `replace: true` here (unlike the historical version of this button):
                that turned an incidental click on a row's Edit action into a rewrite
                of history, so the back button from the editor could never return here.
                See src/components/quotationsTable/table-layout.jsx's own `onClick` for
                the ID cell, which documents the same fix for the ID-click navigation. */}
            {Constants.COLUMNS_FUCTIONALITIES[quotationType].includes("Edit") && < a rel="noreferrer" className="px-4 py-2 rounded-2xl bg-blue-500 cursor-pointer" onClick={() => navigate(`/quotation/edit/${row?.cell?.row?.values?.id}`)}>
                <MdModeEditOutline className=" text-[white] text-xl" />
            </a>}

        </div >
    );

};

// Order Status Column with ts Functions
const Cell2 = (row, type, types, refetchOrders) => {
    return (
        <div className="px-2 text-black">
            <select
                style={{
                    border: "1px solid #b0b5ba",
                    borderRadius: "6px"
                }}
                className="w-[100%] "
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onChange={async (e) => {
                    try {
                        const response =
                            await request({
                                method: "PUT",
                                url: `/quotation/admin/id/${row.row.original.id}`,
                                data: type === 'status' ? {
                                    status: Constants.STATUS_MAP_REVERSE[e.target.value]
                                } : {
                                    type: e.target.value === 'ACTIVE' ? 'QUOTATION_ACTIVE' : e.target.value === 'PENDING' ? 'QUOTATOIN_PENDING' : e.target.value === 'PAYMENT_PENDING' ? 'PAYMENT_PENDING' : 'QUOTATOIN_CANCELLED'
                                }
                            })

                        if (!response.data.success) {
                            toast.warn("Please Try After Sometime")
                        } else {
                            refetchOrders()
                        }
                    }
                    catch (err) {
                        toast.warn("Please Try After Sometime")
                    }
                }}>
                {
                    types?.map((value) => {
                        return (
                            <option selected={Constants.STATUS_MAP[row?.row?.original?.status] === value} key={value} value={value}>{value}</option>
                        )
                    })
                }
            </select>
        </div>
    );
};

function TableInstance({ tableData, pageCount, setPageSort, pageSort, handleDeleteRow, refetchOrders }) {
    const { quotationType } = useContext(QuotationsData);
    const [modal, showModal] = React.useState(false);
    const reOrderModalClick = () => {
        showModal(!modal);
    };
    const [columns, data] = useMemo(() => {
        let columns;
        switch (quotationType) {
            case PRESORTED_QUOTATIONS_TYPE:
                columns = baseColumns;
                columns = [
                    ...columns,
                    {
                        Header: "Status",
                        accessor: "status",
                        Cell: (row) => Cell2(row, 'status', Object.values(Constants.STATUS_MAP), refetchOrders)
                    },
                ];
                break;
            case STRIPS_QUOTATIONS_TYPE:
                columns = baseColumns;
                columns = [
                    ...columns,
                    {
                        Header: "Status",
                        accessor: "status",
                        Cell: (row) => Cell2(row, 'status', Object.values(Constants.STATUS_MAP), refetchOrders)
                    },
                ];
                break;
            case ALL_QUOTATIONS_TYPE:
                columns = baseColumns;
                columns = [
                    ...columns,
                    {
                        Header: "Status",
                        accessor: "status",
                        Cell: (row) => Cell2(row, 'status', Object.values(Constants.STATUS_MAP), refetchOrders)
                    },
                ];
                break;
            default:
                columns = baseColumns;
                break;
        }
        columns = [
            ...columns,
            {
                Header: "Action",
                accessor: "action",
                Cell: (row) => Cell(row, reOrderModalClick, handleDeleteRow, quotationType),
            },
        ];
        return [columns, tableData];
    }, [tableData, baseColumns]);

    const tableInstance = useTable(
        {
            columns,
            data,
            initialState: { sortBy: pageSort },
            manualSortBy: true,
            autoResetSortBy: false,
            autoResetExpanded: false,
            autoResetPage: false,
        },
        useSortBy
    );

    return (
        <TableLayout {...tableInstance}
            pageCount={pageCount}
            setPageSort={setPageSort}
            refetchOrders={refetchOrders}
        />
    );
}

export default TableInstance;

TableInstance.propTypes = {
    tableData: PropTypes.array.isRequired,
    pageCount: PropTypes.number,
    setPageSort: PropTypes.any,
    pageSort: PropTypes.any,
    RowSelectHandler: PropTypes.any,
    SelectedRows: PropTypes.any
    // setOrderChanged: PropTypes.any
};

Cell.propTypes = {
    row: PropTypes.any,
};